<template>
  <footer>
    <div class="footer-top">
      <div class="container wd-container">
        <div class="row">
          <div class="col-xl-4 pb-3 pb-xl-0">
            <div class="block about">
              <div class="foo-logo">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 154.2 39.3"
                  style="enable-background: new 0 0 154.2 39.3"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        class="st0"
                        d="M24.9,11.9c-1.4,0-2.6,1.2-2.6,2.6v2.6v1.2v2.8v0.8v0.4v5.2v1.2v2.8v1.2h-1.2h-2.8h-1.2v-1.2v-2.8v-1.2v-5.2
                  v-0.4v-0.8v-2.8v-1.2v-2.6c0-0.2,0-0.4-0.1-0.5c-0.2-0.9-0.8-1.6-1.7-1.9c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2-0.1
                  c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.5,0.1c-0.1,0-0.2,0-0.2,0.1c-0.3,0.1-0.5,0.2-0.8,0.4c0,0-0.1,0.1-0.1,0.1
                  c-0.5,0.4-0.8,1-0.9,1.7c0,0.1,0,0.2,0,0.3v2.6v4.8v0.4v2.6c0,0.9-0.2,1.8-0.4,2.6c-0.8,2.2-2.5,4-4.8,4.8
                  c-0.8,0.3-1.7,0.4-2.6,0.4c-0.7,0-1.4-0.1-2.1-0.3c3.2,3.2,7.6,5.1,12.5,5.1c5.1,0,9.8-2.2,13-5.6v-4.4v-5.2v-0.4v-4.8v-2.6
                  C27.5,13,26.4,11.9,24.9,11.9z"
                      />
                      <path
                        class="st0"
                        d="M4.1,27.5c1.4,0,2.6-1.2,2.6-2.6v-2.6v-4.8v-0.4v-2.6c0-0.9,0.2-1.8,0.4-2.6c0.8-2.2,2.5-4,4.8-4.8
                  c0.8-0.3,1.7-0.4,2.6-0.4c0.9,0,1.8,0.2,2.6,0.4c1,0.3,1.9,0.9,2.6,1.5c0.8-0.7,1.6-1.2,2.6-1.5c0.8-0.3,1.7-0.4,2.6-0.4
                  c0.7,0,1.4,0.1,2.1,0.3c-3.2-3.2-7.6-5.1-12.5-5.1c-5.1,0-9.8,2.2-13,5.6v0.4v2.8v1.2v5.2v0.4v4.8v2.6C1.5,26.3,2.6,27.5,4.1,27.5
                  z"
                      />
                    </g>
                    <g>
                      <g>
                        <g>
                          <g>
                            <path
                              class="st0"
                              d="M47.2,24c0.3,0,0.6,0.3,0.6,0.6v2.8c0,0.3-0.3,0.6-0.6,0.6H32.5c-0.3,0-0.6-0.3-0.6-0.6V5.7
                        c0-0.3,0.3-0.6,0.6-0.6h2.8c0.3,0,0.6,0.3,0.6,0.6v17.8c0,0.3,0.3,0.6,0.6,0.6H47.2z"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              class="st0"
                              d="M60.5,11.7c0-0.3,0.3-0.6,0.6-0.6h2.5c0.3,0,0.6,0.3,0.6,0.6v8c0,0.3,0,0.8-0.1,1.1c0,0-0.1,1.3-0.5,2.2
                        c-0.4,0.9-0.9,1.6-1.5,2.3c-0.6,0.7-1.4,1.2-2.3,1.6c-0.9,0.4-1.8,0.6-2.8,0.6c-1,0-1.9-0.2-2.8-0.6c-0.9-0.4-1.6-0.9-2.3-1.6
                        c-0.7-0.7-1.2-1.4-1.6-2.3c-0.4-0.9-0.6-1.8-0.6-2.8v-8.6c0-0.3,0.3-0.6,0.6-0.6h2.5c0.3,0,0.6,0.3,0.6,0.6v8
                        c0,0.3,0,0.8,0.1,1.1c0,0,0,0.4,0.2,0.8c0.2,0.4,0.4,0.8,0.8,1.1c0.3,0.3,0.7,0.6,1.1,0.7c0.4,0.2,0.9,0.3,1.4,0.3
                        c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.4,1.1-0.7c0.3-0.3,0.6-0.7,0.8-1.1c0.2-0.4,0.3-0.9,0.3-1.3V11.7z"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              class="st0"
                              d="M66.4,11.6c-0.1-0.3,0-0.5,0.3-0.5h3c0.3,0,0.7,0.2,0.8,0.5l4.2,9.7c0.1,0.3,0.3,0.3,0.5,0l4.2-9.7
                        c0.1-0.3,0.5-0.5,0.8-0.5h3c0.3,0,0.5,0.2,0.3,0.5l-6.7,15.3c-0.1,0.3-0.5,0.5-0.8,0.5h-2.2c-0.3,0-0.7-0.2-0.8-0.5L66.4,11.6z
                        "
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              class="st0"
                              d="M85.8,6.5c0-0.5,0.2-1,0.5-1.4c0.4-0.4,0.8-0.5,1.3-0.5c0.5,0,1,0.2,1.4,0.5c0.4,0.4,0.5,0.8,0.5,1.4
                        c0,0.5-0.2,0.9-0.5,1.3c-0.4,0.4-0.8,0.5-1.4,0.5c-0.5,0-0.9-0.2-1.3-0.5C86,7.5,85.8,7.1,85.8,6.5z M85.7,11.7
                        c0-0.3,0.3-0.6,0.6-0.6H89c0.3,0,0.6,0.3,0.6,0.6v15.2c0,0.3-0.3,0.6-0.6,0.6h-2.7c-0.3,0-0.6-0.3-0.6-0.6V11.7z"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              class="st0"
                              d="M91.6,12.4c0-0.3,0.3-0.6,0.6-0.6h2.5c0.3,0,0.6,0.2,0.6,0.4c0,0.2,0.2,0.3,0.4,0c0,0,0.6-0.6,1.1-0.8
                        c0.5-0.2,1.2-0.4,1.9-0.4c1.1,0,2,0.2,2.9,0.6c0.9,0.4,1.6,1,2.3,1.7c0.7-0.7,1.5-1.3,2.4-1.7c0.9-0.4,1.9-0.6,3-0.6
                        c1,0,1.9,0.2,2.8,0.6c0.9,0.4,1.6,0.9,2.2,1.5c0.6,0.6,1.1,1.4,1.5,2.3c0.4,0.9,0.6,1.8,0.6,2.8v8.6c0,0.3-0.3,0.6-0.6,0.6
                        h-2.5c-0.3,0-0.6-0.3-0.6-0.6v-8.1c0-0.3,0-0.8-0.1-1.1c0,0,0-0.3-0.2-0.7c-0.2-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.6-1.1-0.7
                        c-0.4-0.2-0.9-0.3-1.3-0.3c-0.5,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.8,0.4-1.1,0.7c-0.3,0.3-0.6,0.7-0.7,1.1
                        c-0.2,0.4-0.3,0.9-0.3,1.3v8.6c0,0.3-0.3,0.6-0.6,0.6h-2.5c-0.3,0-0.6-0.3-0.6-0.6v-8.1c0-0.3,0-0.8-0.1-1.1c0,0,0-0.4-0.2-0.8
                        c-0.2-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.3-1.3-0.3c-0.5,0-0.9,0.1-1.3,0.3
                        c-0.4,0.2-0.8,0.4-1.1,0.8c-0.3,0.3-0.6,0.7-0.7,1.1c-0.2,0.4-0.3,0.8-0.3,1.3v8.6c0,0.3-0.3,0.6-0.6,0.6h-2.5
                        c-0.3,0-0.6-0.3-0.6-0.6V12.4z"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              class="st0"
                              d="M118.2,19.2c0-1.1,0.2-2.2,0.6-3.2c0.4-1,1-1.8,1.8-2.6c0.7-0.7,1.6-1.3,2.6-1.7c1-0.4,2.1-0.6,3.2-0.6
                        c1.1,0,2.2,0.2,3.2,0.6c1,0.4,1.8,1,2.6,1.7c0.7,0.7,1.3,1.6,1.7,2.6c0.4,1,0.6,2.1,0.6,3.2v7c0,0.3-0.3,0.6-0.6,0.6h-2.3
                        c-0.3,0-0.6-0.2-0.6-0.4s-0.2-0.3-0.5-0.2c0,0-2.4,1.2-4.2,1.2c-1.2,0-2.4-0.2-3.4-0.6c-1-0.4-1.9-1-2.6-1.7
                        c-0.7-0.7-1.3-1.6-1.6-2.6C118.4,21.4,118.2,20.4,118.2,19.2z M121.7,19.2c0,0.6,0.1,1.2,0.4,1.8c0.3,0.6,0.6,1.1,1,1.5
                        c0.4,0.4,0.9,0.8,1.5,1c0.6,0.3,1.2,0.4,1.8,0.4c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.1-0.6,1.5-1c0.4-0.4,0.8-0.9,1-1.5
                        c0.3-0.6,0.4-1.2,0.4-1.9c0-0.6-0.1-1.2-0.4-1.8c-0.3-0.6-0.6-1.1-1-1.5c-0.4-0.4-0.9-0.8-1.5-1c-0.6-0.2-1.2-0.4-1.8-0.4
                        c-0.6,0-1.2,0.1-1.8,0.4c-0.6,0.3-1.1,0.6-1.5,1c-0.4,0.4-0.8,0.9-1,1.5C121.8,18,121.7,18.6,121.7,19.2z"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              class="st0"
                              d="M140.1,19.2c0,0.6,0.1,1.3,0.4,1.8c0.3,0.6,0.6,1.1,1,1.5c0.4,0.4,0.9,0.8,1.5,1c0.6,0.3,1.2,0.4,1.8,0.4
                        c0.8,0,1.5-0.1,2.1-0.4c0.6-0.3,1.2-0.7,1.6-1.3h3.4c0.3,0,0.5,0.2,0.3,0.5c0,0-0.6,1.2-1.1,1.8c-0.6,0.7-1.2,1.2-1.8,1.6
                        c-0.7,0.4-1.4,0.7-2.1,0.9c-0.7,0.2-1.5,0.3-2.3,0.3c-1.1,0-2.2-0.2-3.2-0.6c-1-0.4-1.9-1-2.6-1.7c-0.7-0.7-1.3-1.6-1.7-2.6
                        c-0.4-1-0.6-2.1-0.6-3.2c0-1.1,0.2-2.2,0.6-3.2c0.4-1,1-1.9,1.7-2.6c0.7-0.7,1.6-1.3,2.6-1.7c1-0.4,2.1-0.6,3.2-0.6
                        c0.7,0,1.5,0.1,2.2,0.3c0.8,0.2,1.5,0.5,2.1,0.9c0.7,0.4,1.3,1,1.9,1.6c0.6,0.7,1,1.4,1.4,2.4H149c-0.3,0-0.7-0.2-1-0.4
                        c0,0-0.6-0.6-1.2-0.9c-0.6-0.3-1.3-0.4-2.1-0.4c-0.6,0-1.3,0.1-1.8,0.4c-0.6,0.3-1.1,0.6-1.5,1c-0.4,0.4-0.8,0.9-1,1.5
                        C140.2,18,140.1,18.6,140.1,19.2z"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <path
                              class="st0"
                              d="M33.5,32.6c0,0.1,0,0.1,0,0.2l1.5,1.8c0,0.1,0,0.1,0,0.1h-0.7c-0.1,0-0.2,0-0.2-0.1L32.8,33
                        c0-0.1-0.1,0-0.1,0v1.5c0,0.1-0.1,0.1-0.1,0.1h-0.5c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1h0.5
                        c0.1,0,0.1,0.1,0.1,0.1v1.5c0,0.1,0,0.1,0.1,0l1.3-1.5c0-0.1,0.1-0.1,0.2-0.1H35c0.1,0,0.1,0,0,0.1L33.5,32.6z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M39,31.4c-0.1,0-0.1,0.1-0.1,0.1v0.7c0,0.1,0.1,0.1,0.1,0.1h1.1c0.1,0,0.1,0.1,0.1,0.1v0.3
                        c0,0.1-0.1,0.1-0.1,0.1H39c-0.1,0-0.1,0.1-0.1,0.1v0.8c0,0.1,0.1,0.1,0.1,0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v0.4
                        c0,0.1-0.1,0.1-0.1,0.1h-2c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1h2c0.1,0,0.1,0.1,0.1,0.1v0.3
                        c0,0.1-0.1,0.1-0.1,0.1H39z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M44.4,31.4c-0.1,0-0.1,0.1-0.1,0.1v0.7c0,0.1,0.1,0.1,0.1,0.1h1.1c0.1,0,0.1,0.1,0.1,0.1v0.3
                        c0,0.1-0.1,0.1-0.1,0.1h-1.1c-0.1,0-0.1,0.1-0.1,0.1v0.8c0,0.1,0.1,0.1,0.1,0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v0.4
                        c0,0.1-0.1,0.1-0.1,0.1h-2c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1h2c0.1,0,0.1,0.1,0.1,0.1v0.3
                        c0,0.1-0.1,0.1-0.1,0.1H44.4z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M49.8,33.2c-0.1,0-0.1,0.1-0.1,0.1v1.2c0,0.1-0.1,0.1-0.1,0.1H49c-0.1,0-0.1-0.1-0.1-0.1v-3.6
                        c0-0.1,0.1-0.1,0.1-0.1h1.1c0.1,0,0.2,0,0.3,0c0,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.5,0.3,0.9c0,0.4-0.1,0.7-0.4,0.9
                        c-0.2,0.2-0.9,0.3-0.9,0.3c-0.1,0-0.2,0-0.3,0H49.8z M50.9,32c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.4-0.1-0.4-0.1
                        c-0.1,0-0.2,0-0.3,0h-0.3c-0.1,0-0.1,0.1-0.1,0.1v0.9c0,0.1,0.1,0.1,0.1,0.1h0.3c0.1,0,0.2,0,0.3,0
                        C50.4,32.5,50.9,32.4,50.9,32z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M61.4,30.8c0.1,0,0.1,0.1,0.1,0.1l-1.2,2.3c0,0.1-0.1,0.2-0.1,0.3v1.1c0,0.1-0.1,0.1-0.1,0.1h-0.5
                        c-0.1,0-0.1-0.1-0.1-0.1v-1.1c0-0.1,0-0.2-0.1-0.3l-1.2-2.3c0-0.1,0-0.1,0.1-0.1h0.6c0.1,0,0.2,0.1,0.2,0.1l0.7,1.5
                        c0,0.1,0.1,0.1,0.1,0l0.7-1.5c0-0.1,0.1-0.1,0.2-0.1H61.4z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M67.3,31c0.3,0.2,0.5,0.4,0.7,0.7c0.2,0.3,0.3,0.6,0.3,1s-0.1,0.7-0.3,1c-0.2,0.3-0.4,0.5-0.7,0.7
                        c-0.3,0.2-0.6,0.3-1,0.3s-0.7-0.1-1-0.3c-0.3-0.2-0.5-0.4-0.7-0.7c-0.2-0.3-0.3-0.6-0.3-1s0.1-0.7,0.3-1
                        c0.2-0.3,0.4-0.5,0.7-0.7c0.3-0.2,0.6-0.3,1-0.3S67,30.8,67.3,31z M65.7,31.6c-0.2,0.1-0.3,0.3-0.4,0.4
                        c-0.1,0.2-0.1,0.4-0.1,0.7s0,0.5,0.1,0.7c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2
                        c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.1-0.4,0.1-0.7s0-0.5-0.1-0.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.2-0.6-0.2
                        S65.9,31.5,65.7,31.6z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M72,30.8c0.1,0,0.1,0.1,0.1,0.1v2c0,0.1,0,0.2,0,0.3c0,0,0.1,0.4,0.2,0.6c0.1,0.2,0.3,0.2,0.6,0.2
                        c0.2,0,0.4-0.1,0.6-0.2c0.1-0.2,0.2-0.6,0.2-0.6c0-0.1,0-0.2,0-0.3v-2c0-0.1,0.1-0.1,0.1-0.1h0.5c0.1,0,0.1,0.1,0.1,0.1v2
                        c0,0.1,0,0.2,0,0.3c0,0-0.1,0.5-0.2,0.8c-0.1,0.2-0.3,0.4-0.6,0.6c-0.2,0.1-0.5,0.2-0.8,0.2c-0.5,0-0.8-0.1-1.1-0.4
                        c-0.3-0.3-0.4-1.1-0.4-1.1c0-0.1,0-0.2,0-0.3v-2c0-0.1,0.1-0.1,0.1-0.1H72z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M79.8,34.6c-0.1,0-0.2-0.1-0.2-0.1l-0.8-1.3c0-0.1-0.1-0.1-0.2-0.1h-0.1c-0.1,0-0.1,0.1-0.1,0.1v1.2
                        c0,0.1-0.1,0.1-0.1,0.1h-0.5c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1H79c0.1,0,0.2,0,0.3,0c0,0,0.7,0.1,0.9,0.3
                        c0.2,0.2,0.4,0.5,0.4,0.9c0,0.3-0.1,0.5-0.2,0.7c-0.2,0.2-0.6,0.3-0.6,0.3c-0.1,0-0.1,0.1-0.1,0.2l0.8,1.3c0,0.1,0,0.1-0.1,0.1
                        H79.8z M78.5,32.5c0,0.1,0.1,0.1,0.1,0.1H79c0.1,0,0.2,0,0.3,0c0,0,0.5-0.2,0.5-0.6c0-0.2-0.1-0.3-0.2-0.4
                        c-0.1-0.1-0.4-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0h-0.4c-0.1,0-0.1,0.1-0.1,0.1V32.5z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M90.5,33.7c-0.2,0.3-0.4,0.5-0.7,0.7c-0.3,0.2-1,0.2-1,0.2c-0.1,0-0.2,0-0.3,0h-1.1
                        c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1h1.1c0.1,0,0.2,0,0.3,0c0,0,0.7,0.1,1,0.2c0.3,0.2,0.5,0.4,0.7,0.7
                        c0.2,0.3,0.2,0.6,0.2,1C90.7,33.1,90.7,33.4,90.5,33.7z M89.6,33.6c0.2-0.2,0.3-0.5,0.3-0.9c0-0.4-0.1-0.7-0.3-0.9
                        c-0.2-0.2-0.8-0.3-0.8-0.3c-0.1,0-0.2,0-0.3,0h-0.3c-0.1,0-0.1,0.1-0.1,0.1v2.2c0,0.1,0.1,0.1,0.1,0.1h0.3c0.1,0,0.2,0,0.3,0
                        C88.8,33.9,89.4,33.8,89.6,33.6z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M96,34.6c-0.1,0-0.2-0.1-0.2-0.1L95,33.2c0-0.1-0.1-0.1-0.2-0.1h-0.1c-0.1,0-0.1,0.1-0.1,0.1v1.2
                        c0,0.1-0.1,0.1-0.1,0.1H94c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1h1.2c0.1,0,0.2,0,0.3,0c0,0,0.7,0.1,0.9,0.3
                        c0.2,0.2,0.4,0.5,0.4,0.9c0,0.3-0.1,0.5-0.2,0.7c-0.2,0.2-0.6,0.3-0.6,0.3c-0.1,0-0.1,0.1-0.1,0.2l0.8,1.3c0,0.1,0,0.1-0.1,0.1
                        H96z M94.6,32.5c0,0.1,0.1,0.1,0.1,0.1h0.4c0.1,0,0.2,0,0.3,0c0,0,0.5-0.2,0.5-0.6c0-0.2-0.1-0.3-0.2-0.4
                        c-0.1-0.1-0.4-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0h-0.4c-0.1,0-0.1,0.1-0.1,0.1V32.5z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M100.7,31.4c-0.1,0-0.1,0.1-0.1,0.1v0.7c0,0.1,0.1,0.1,0.1,0.1h1.1c0.1,0,0.1,0.1,0.1,0.1v0.3
                        c0,0.1-0.1,0.1-0.1,0.1h-1.1c-0.1,0-0.1,0.1-0.1,0.1v0.8c0,0.1,0.1,0.1,0.1,0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v0.4
                        c0,0.1-0.1,0.1-0.1,0.1h-2c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1h2c0.1,0,0.1,0.1,0.1,0.1v0.3
                        c0,0.1-0.1,0.1-0.1,0.1H100.7z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M107.6,34c0-0.1-0.1-0.1-0.2-0.1h-1.3c-0.1,0-0.2,0.1-0.2,0.1l-0.2,0.5c0,0.1-0.1,0.1-0.2,0.1H105
                        c-0.1,0-0.1-0.1-0.1-0.1l1.3-3.6c0-0.1,0.1-0.1,0.2-0.1h0.6c0.1,0,0.2,0.1,0.2,0.1l1.3,3.6c0,0.1,0,0.1-0.1,0.1h-0.6
                        c-0.1,0-0.2-0.1-0.2-0.1L107.6,34z M107.2,33.3c0.1,0,0.1-0.1,0.1-0.1l-0.5-1.4c0-0.1-0.1-0.1-0.1,0l-0.5,1.4
                        c0,0.1,0,0.1,0.1,0.1H107.2z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M115.6,30.8c0.1,0,0.1,0.1,0.1,0.1v3.6c0,0.1-0.1,0.1-0.1,0.1h-0.5c-0.1,0-0.1-0.1-0.1-0.1v-2.4
                        c0-0.1,0-0.1,0,0l-0.9,2.4c0,0.1-0.1,0.1-0.2,0.1h-0.4c-0.1,0-0.2-0.1-0.2-0.1l-0.9-2.4c0-0.1,0-0.1,0,0v2.4
                        c0,0.1-0.1,0.1-0.1,0.1h-0.5c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1h0.7c0.1,0,0.2,0.1,0.2,0.1l1.1,2.6
                        c0,0.1,0.1,0.1,0.1,0l1-2.6c0-0.1,0.1-0.1,0.2-0.1H115.6z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M121.5,34.1c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.1-0.4,0.2-0.7,0.2c-0.3,0-0.5,0-0.7-0.1
                        c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.2-0.5-0.2-0.5c0-0.1,0-0.1,0.1-0.1h0.6c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0.2,0.2,0.3
                        c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.2
                        c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.2-0.2-0.3-0.2-0.6c0-0.3,0.1-0.6,0.4-0.8
                        c0.2-0.2,0.6-0.3,1-0.3c0.4,0,0.7,0.1,1,0.3c0.2,0.2,0.4,0.7,0.4,0.7c0,0.1,0,0.1-0.1,0.1h-0.6c-0.1,0-0.2-0.1-0.2-0.1
                        c0,0,0-0.1-0.1-0.2c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3
                        c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.4,0.2c0.2,0.1,0.5,0.2,0.6,0.2c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.2,0.2,0.4,0.2,0.6
                        C121.7,33.8,121.6,34,121.5,34.1z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M130.9,34c0-0.1-0.1-0.1-0.2-0.1h-1.3c-0.1,0-0.2,0.1-0.2,0.1l-0.2,0.5c0,0.1-0.1,0.1-0.2,0.1h-0.6
                        c-0.1,0-0.1-0.1-0.1-0.1l1.3-3.6c0-0.1,0.1-0.1,0.2-0.1h0.6c0.1,0,0.2,0.1,0.2,0.1l1.3,3.6c0,0.1,0,0.1-0.1,0.1h-0.6
                        c-0.1,0-0.2-0.1-0.2-0.1L130.9,34z M130.5,33.3c0.1,0,0.1-0.1,0.1-0.1l-0.5-1.4c0-0.1-0.1-0.1-0.1,0l-0.5,1.4
                        c0,0.1,0,0.1,0.1,0.1H130.5z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M135.7,33.9c0,0.1,0.1,0.1,0.1,0.1h1c0.1,0,0.1,0.1,0.1,0.1v0.3c0,0.1-0.1,0.1-0.1,0.1H135
                        c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1h0.5c0.1,0,0.1,0.1,0.1,0.1V33.9z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M140.6,30.8c0.1,0,0.1,0.1,0.1,0.1v3.6c0,0.1-0.1,0.1-0.1,0.1h-0.5c-0.1,0-0.1-0.1-0.1-0.1v-3.6
                        c0-0.1,0.1-0.1,0.1-0.1H140.6z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M144.4,30.8c0.1,0,0.2,0.1,0.2,0.1l1,2.8c0,0.1,0.1,0.1,0.1,0l1-2.8c0-0.1,0.1-0.1,0.2-0.1h0.6
                        c0.1,0,0.1,0.1,0.1,0.1l-1.3,3.6c0,0.1-0.1,0.1-0.2,0.1h-0.7c-0.1,0-0.2-0.1-0.2-0.1l-1.3-3.6c0-0.1,0-0.1,0.1-0.1H144.4z"
                            />
                          </g>
                          <g>
                            <path
                              class="st0"
                              d="M151.3,31.4c-0.1,0-0.1,0.1-0.1,0.1v0.7c0,0.1,0.1,0.1,0.1,0.1h1.1c0.1,0,0.1,0.1,0.1,0.1v0.3
                        c0,0.1-0.1,0.1-0.1,0.1h-1.1c-0.1,0-0.1,0.1-0.1,0.1v0.8c0,0.1,0.1,0.1,0.1,0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v0.4
                        c0,0.1-0.1,0.1-0.1,0.1h-2c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.1,0.1-0.1,0.1-0.1h2c0.1,0,0.1,0.1,0.1,0.1v0.3
                        c0,0.1-0.1,0.1-0.1,0.1H151.3z"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <p>
                Luvimac is your one stop expert team for web design, mobile app
                development and online marketing. From here we provide online
                branding for promising start-ups and innovative corporate
                services. Luvimac makes your creative website ensure modern
                UI-UX, responsive web design and high conversion. Without
                hassle.
              </p>
            </div>
          </div>
          <div class="col-xl-8">
            <div class="footer-menu">
              <div class="accordion" id="footer-accordion">
                <div class="accordion-item">
                  <h3 class="collapsed" data-bs-toggle="collapse" data-bs-target="#acc-content-1">Company <span class="icon-box"><Icon name="down-arrow-icon" :width="16" :height="16" /></span></h3>
                  <div id="acc-content-1" class="accordion-collapse collapse" data-bs-parent="#footer-accordion">
                    <div class="accordion-body">
                      <ul>
												<li><router-link to="/">Home</router-link></li>
												<li><router-link to="/about">About Us</router-link></li>
                        <li><router-link to="/contact-us">Contact Us</router-link></li>
											</ul>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h3 class="collapsed" data-bs-toggle="collapse" data-bs-target="#acc-content-2">Capabilities<span class="icon-box"><Icon name="down-arrow-icon" :width="16" :height="16" /></span></h3>
                  <div id="acc-content-2" class="accordion-collapse collapse" data-bs-parent="#footer-accordion">
                    <div class="accordion-body">
                      <ul>
												<li><a>Design</a></li>
												<li><a>Development</a></li>
												<li><a>Business Consulting</a></li>
												<li><a>Technology Consulting</a></li>
												<li><a>Staff Augmentation</a></li>
												<li><a>Hire On-Demand</a></li>
												<li><a>SEO Marketing</a></li>
											</ul>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h3 class="collapsed" data-bs-toggle="collapse" data-bs-target="#acc-content-3">Solutions<span class="icon-box"><Icon name="down-arrow-icon" :width="16" :height="16" /></span></h3>
                  <div id="acc-content-3" class="accordion-collapse collapse" data-bs-parent="#footer-accordion">
                    <div class="accordion-body">
                      <ul>
												<li><a>eLearning</a></li>
												<li><a>eCommerce</a></li>
												<li><a>Web Portals</a></li>
												<li><a>Low Code Solutions</a></li>
												<li><a>No Code Solutions</a></li>
												<li><a>Logistics</a></li>
											</ul>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h3 class="collapsed" data-bs-toggle="collapse" data-bs-target="#acc-content-4">Technologies<span class="icon-box"><Icon name="down-arrow-icon" :width="16" :height="16" /></span></h3>
                  <div id="acc-content-4" class="accordion-collapse collapse" data-bs-parent="#footer-accordion">
                    <div class="accordion-body">
                      <ul>
                        <li><router-link to="/technology">Technology</router-link></li>
                        <li><router-link to="/wordpress-website-development">WordPress</router-link></li>
                        <li><router-link to="/magento-ecommerce-development">Magento</router-link></li>
                        <li><router-link to="/android-app-development">Android App</router-link></li>
                        <li><router-link to="/ios-app-development">iOS App</router-link></li>
                        <li><router-link to="/flutter-app-development">Flutter App</router-link></li>
											</ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container wd-container">
        <div class="row align-items-center">
          <div class="col-md-3 pb-3 pb-md-0 text-center text-md-start">
            <ul class="footer-link">
              <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
            </ul>
          </div>
          <div class="col-md-6 pb-3 pb-md-0 text-center">
            <p classs="copyrights">
              Copyright &copy; {{ copyrightYear }}
              <router-link to="/">Luvimac.com</router-link> | All Rights
              Reserved.
            </p>
          </div>
          <div class="col-md-3 text-center text-md-end">
            <ul class="social footer">
                <li v-for="social of socialLinks" :key="social.id">
                  <a :href="social.link" v-html="social.icon" target="_blank"> </a>
                </li>
              </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import Icon from '../inc/Icon.vue';
export default {
  name: "Footer",
  components: { Icon },
  data() {
    return {
      copyrightYear: "",
      socialLinks: [
        {
          id: 1,
          title: "Facebook",
          icon: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve"> <title>facebook</title> <path d="M17.9,8.4h-3.7V5.9c0-0.9,0.6-1.1,1-1.1h2.6v-4h-3.6c-4,0-4.9,3-4.9,4.9v2.7H7.1v4.1h2.3v11.6h4.8V12.5h3.3L17.9,8.4 L17.9,8.4z"/> </svg>',
          link: "https://www.facebook.com/luvimac",
        },
        {
          id: 2,
          title: "Twitter",
          icon: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve"> <title>twitter</title> <path d="M24.4,5.1c-0.9,0.4-1.8,0.6-2.8,0.8c1-0.6,1.8-1.6,2.1-2.7c-0.9,0.6-2,1-3.1,1.2c-0.9-0.9-2.1-1.5-3.5-1.5 c-2.7,0-4.9,2.2-4.9,4.9c0,0.4,0,0.8,0.1,1.1c-4-0.2-7.6-2.1-10-5.1C1.8,4.4,1.6,5.2,1.6,6.1c0,1.7,0.9,3.2,2.2,4 c-0.8,0-1.5-0.2-2.2-0.6v0.1c0,2.4,1.7,4.3,3.9,4.8c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6,0-0.9-0.1c0.6,1.9,2.4,3.3,4.5,3.4 C6.1,19.2,4,20,1.8,20c-0.4,0-0.8,0-1.2-0.1c2.2,1.4,4.7,2.2,7.4,2.2c8.9,0,13.8-7.4,13.8-13.8c0-0.2,0-0.4,0-0.6 C22.9,6.9,23.6,6,24.4,5.1L24.4,5.1z"/> </svg>',
          link: "https://twitter.com/luvimacs",
        },
        {
          id: 3,
          title: "Instagram",
          icon: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve"> <g> <path d="M12.5,6C9,6,6.1,8.9,6.1,12.4s2.9,6.4,6.4,6.4s6.4-2.9,6.4-6.4S16,6,12.5,6L12.5,6z M12.5,16.3c-2.2,0-3.9-1.8-3.9-3.9 s1.8-3.9,3.9-3.9s3.9,1.8,3.9,3.9S14.7,16.3,12.5,16.3z M17.7,0.2H7.3c-3.9,0-7.1,3.2-7.1,7.1v10.4c0,3.9,3.2,7.1,7.1,7.1h10.4 c3.9,0,7.1-3.2,7.1-7.1V7.2C24.8,3.3,21.6,0.2,17.7,0.2L17.7,0.2z M22.3,17.6c0,2.5-2.1,4.6-4.6,4.6H7.3c-2.5,0-4.6-2.1-4.6-4.6 V7.2c0-2.5,2.1-4.6,4.6-4.6h10.4c2.5,0,4.6,2.1,4.6,4.6L22.3,17.6L22.3,17.6z M18.9,4.2c-0.9,0-1.6,0.7-1.6,1.7 c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7S19.9,4.2,18.9,4.2z"/> </g> </svg>',
          link: "https://www.instagram.com/luvimac/",
        },
        {
          id: 4,
          title: "Linkdin",
          icon: '<svg version="1.1" id="Bold" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve"> <g> <path d="M24.6,24.6L24.6,24.6L24.6,24.6l0-8.8c0-4.3-0.9-7.7-6-7.7c-2.4,0-4.1,1.3-4.7,2.6h-0.1V8.5H9v16.1h5v-8 c0-2.1,0.4-4.1,3-4.1c2.6,0,2.6,2.4,2.6,4.3v7.8L24.6,24.6z"/> <path d="M0.8,8.5h5v16.1h-5L0.8,8.5z"/> <path d="M3.3,0.4c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9C6.2,1.7,4.9,0.4,3.3,0.4z"/> </g> </svg>',
          link: "https://www.linkedin.com/company/luvimac",
        }
      ],
    };
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    this.$set(this, "copyrightYear", currentYear);
  },
};
</script>

<style lang="scss" scoped>
footer {
  overflow: hidden;
  background-color: var(--footer-bg);
  .footer-top {
    padding: 80px 0px 50px;
    overflow: hidden;
  }
  .foo-logo {
    margin-bottom: 15px;
    svg {
      width: 175px;
      fill: var(--font-stl-two);
    }
  }

  .block {
    &.about {
      p {
        color: rgba(240, 240, 240, 0.7) !important;
      }
    }
  }
  .footer-menu {
    .accordion {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px -30px;
      .accordion-item {
        width: 25%;
        padding: 0px 15px 30px;
        border: none;
        background: none;
        h3 {
          font-size: 16px;
          font-weight: 600;
          color: var(--font-stl-two);
          text-transform: uppercase;
          margin: 0 0 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
      .accordion-body {
        padding: 0;
        ul {
          li {
            display: block;
            width: 100%;
            &:not(:last-child) {
              padding: 0 0 10px;
            }
            a {
              font-size: 16px;
              font-weight: 400;
              line-height: 1.2;
              color: rgba(240, 240, 240, 0.7) !important;
              padding-left: 15px;
              padding: 8px 0px 8px 15px;
              position: relative;
              &:before {
                content: "\eaca";
                position: absolute;
                left: -3px;
                top: 12px;
                font-size: 12px;
                font-family: IcoFont;
                font-weight: 400;
                color: rgba(240, 240, 240, 0.7) !important;
                transition: all 0.3s;
              }
              &:hover {
                background: none;
                color: var(--w-color) !important;
                &:before {
                  color: var(--w-color) !important;
                  left: 0px;
                }
              }
            }
          }
        }
      }
    }
  }
  .footer-bottom {
    padding: 20px 0px;
    border-top: 1px solid;
    p {
      margin-bottom: 0px;
      font-size: 14px;
      color: rgba(240, 240, 240, 0.7) !important;
      a {
        font-size: 14px;
        color: rgba(240, 240, 240, 0.7) !important;
      }
    }
    ul.footer-link {
      display: inline-flex  ;
      flex-wrap: wrap;
      li {
        padding: 0px 10px;
        a {
          color: rgba(240, 240, 240, 0.7) !important;
          font-size: 14px;
        }
      }
    }
  }
  @media(min-width:768px){
    .footer-menu {
      .accordion {
        h3{
          pointer-events: none;
          .icon-box{display: none;}
        }
        .accordion-collapse {
          display: block !important;
        }
      }
    }
  }
  @media(max-width:991px){
    .footer-top{
      padding: 50px 0px 50px;
    }
  }
  @media(max-width:767px){
    .footer-top{
      padding: 35px 0px 35px;
    }
    .footer-menu {
      .accordion{
        flex-direction: column;
        .accordion-item{
          width: 100%;
          padding: 0px 15px 15px;
          h3{
            margin: 0;
            padding: 3px 0;
            .icon-box{
              padding: 5px;
              .icon{
                transition: all 0.3s ease-in-out;
              }
            }
            &:not(.collapsed){
              .icon-box{
                .icon{
                  transform: rotate(180deg);
                }
              }
            }
          }
          .accordion-body{
            padding: 15px 0 0;
          }
        }
      }
    }
  }
}

</style>